module.exports = "/packs/media/modules/welcome/welcome/faq/assets/StartHubGuide-2c5082d23f4aefe21bc0adc6d451d8bc.pdf";